const getFilteredData=async (data,payload)=>{

    const { page=0,hitsPerPage=100,facets,filters={},sort_field,sort_direction }=payload
  
    let facetCount={}
  


    let filterdata= data.filter(value=>{
  
        for(let [filterName,filterValue] of Object.entries(filters)){
  
            if (value[filterName]==undefined) return false
  
            if(new Set([...convertToArray(filterValue),...convertToArray(value[filterName])]).size
            ==(new Set(convertToArray(filterValue)).size) + (new Set(convertToArray(value[filterName])).size))
                return false
        }
        
        facets.forEach(facetName=>{
  
            if(!value[facetName]) return 
  
            if(Array.isArray(value[facetName]))
          
                value[facetName].forEach(facet=>facetCount=updatefacetCount(facetCount,facetName,facet))
        
            else if (typeof(value[facetName])=='string') 
                facetCount=updatefacetCount(facetCount,facetName,value[facetName])
        })
      
        return true
    })
  
    if (sort_field)
        filterdata=filterdata.sort((data1,data2)=>{
        
            const [firstVal,secondVal]=sort_direction=='desc'?[data2[sort_field],data1[sort_field]]:[data1[sort_field],data2[sort_field]]  
  
            if ((!firstVal|| typeof(firstVal)=='object') && !secondVal|| (typeof(secondval)=='object')) return 0
        
            if (!firstVal|| typeof(firstVal)=='object') return -1
  
            if (!secondVal|| typeof(secondVal)=='object') return 1
  
            if (typeof(firstVal)=='number'|| typeof(secondVal)=='number')
                return (parseFloat(firstVal)||0)-(parseFloat(secondVal)||0) 
          
            if (typeof(firstVal)=='string'|| typeof(secondVal)=='string')
                return firstVal.localeCompare(secondVal,'es',{ ignorePunctuation:true,sensitivity:'base' })
  
            return 0
        })
  
    const nbHits=filterdata.length
    const hits=filterdata.slice(page*hitsPerPage,(page+1)*hitsPerPage)



    return{
        hitsPerPage,
        facets:facetCount,
        nbPages:Math.ceil(nbHits/hitsPerPage),
        nbHits,
        hits  
    }
  
}
  
const convertToArray=(value)=>(((Array.isArray(value)&& value)||(typeof(value)=='string'&&[value])||[]))
  
const updatefacetCount=(facetCount,facetName,facet)=>{
  
    if (facetCount?.[facetName]?.[facet]) facetCount[facetName][facet]=facetCount[facetName][facet]+1
    else facetCount[facetName]={ ...facetCount[facetName],[facet]:1 }
  
    return facetCount
}
  
export default getFilteredData